import React, { cloneElement } from 'react';
import { toSingleton, generateRandomString } from './utils/index.mjs';
import deepMap from './utils/deepMap.mjs';

const reactRecursiveChildrenMap = deepMap.bind(deepMap);
const generateLocalIdMap = toSingleton(() => new Map());
const localIdsMap = generateLocalIdMap();
const SvgUniqueID = _ref => {
  let {
    children,
    prefixId = '__SVG_ID__',
    id = generateRandomString()
  } = _ref;
  let lastLocalId = 0;
  const getHookedId = originalId => {
    if (!originalId) {
      return null;
    }
    if (!localIdsMap.has(originalId)) {
      localIdsMap.set(originalId, lastLocalId++);
    }
    const localId = localIdsMap.get(originalId);
    return `${prefixId}${id}__${localId}__`;
  };
  const fixPropWithUrl = prop => {
    if (typeof prop !== 'string') {
      return prop;
    }
    const [, originalId] = prop.match(/^url\(#(.*)\)$/) || [null, null];
    if (originalId === null) {
      return prop;
    }
    const fixedId = getHookedId(originalId);
    if (fixedId === null) {
      return prop;
    }
    return `url(#${fixedId})`;
  };
  const getHookedXlinkHref = prop => {
    if (typeof prop !== 'string' || !prop.startsWith('#')) {
      return prop;
    }
    const originalId = prop.replace('#', '');
    const fixedId = getHookedId(originalId);
    if (fixedId === null) {
      return prop;
    }
    return `#${fixedId}`;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, reactRecursiveChildrenMap(children, child => {
    if (!child || typeof child === 'string' || typeof child === 'number' || !('props' in child)) {
      return null;
    }
    const ch = child;
    const fixedId = getHookedId(ch.props.id);
    const fixedProps = {
      ...ch.props
    };
    Object.keys(fixedProps).map(key => fixedProps[key] = fixPropWithUrl(fixedProps[key]));
    return /*#__PURE__*/cloneElement(ch, {
      ...fixedProps,
      id: fixedId,
      xlinkHref: getHookedXlinkHref(ch.props.xlinkHref)
    });
  }));
};

export { SvgUniqueID as default };
